import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117ecdb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "close-btn" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "provider-wrappers mt-6 p-4" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("lukso-icon", {
  name: "link-3",
  class: "mr-2",
  size: "small"
}, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "info mt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider my-4" }, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "header" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("lukso-icon", {
  name: "link-3",
  class: "mr-2",
  size: "small"
}, null, -1 /* HOISTED */))
const _hoisted_12 = { class: "info mt-4" }

import { useI18n } from 'vue-i18n'
import browser from 'webextension-polyfill'
import { ref, watch } from 'vue'

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import Transak from '@/assets/transak.png'
import Ramp from '@/assets/ramp.png'
import { useAppStore } from '@/popup/store/AppStore'
import { EoaAddress } from '@/shared/models/Profile'
import {
  RAMP_PRODUCTION_API_KEY,
  RAMP_PRODUCTION_API_URL,
  TRANSAK_API_KEY,
  TRANSAK_PRODUCTION_API_URL,
  UNIVERSAL_CLOUD_URL,
} from '@/shared/config'
import { ControllerDTO } from '@/business-logic/profile'
import { useProfileStore } from '@/popup/store/ProfileStore'

type Emits = {
  (event: 'on-close'): void
}

const TRANSAK_TITLE_KEY =
  'app.controller_permissions.fund_controller.transak_title'


export default /*#__PURE__*/_defineComponent({
  __name: 'FundExtensionController',
  props: {
    address: {}
  },
  emits: ["on-close"],
  setup(__props: any, { emit: __emit }) {

const { t: $t } = useI18n()

const props = __props

const emits = __emit

const appStore = useAppStore()

const onClose = () => {
  emits('on-close')
}

const createNetworkMapping = (
  network: string,
  cryptoCurrency: string,
  titleKey: string
) => ({
  network,
  defaultCryptoCurrency: cryptoCurrency,
  cryptoCurrencyCode: cryptoCurrency,
  exchangeScreenTitle: $t(titleKey, { currency: cryptoCurrency }),
})

const networkMapping: Record<
  string,
  ReturnType<typeof createNetworkMapping>
> = {
  'ethereum-mainnet': createNetworkMapping(
    'ethereum',
    'ETH',
    $t(TRANSAK_TITLE_KEY, {
      currency: 'ETH',
    })
  ),
  'base-mainnet': createNetworkMapping(
    'base',
    'ETH',
    $t(TRANSAK_TITLE_KEY, {
      currency: 'ETH',
    })
  ),
}

const transakPurchaseUrl = () => {
  const defaultQueryParams: Record<string, string | number> & {
    redirectURL?: string
  } = {
    apiKey: TRANSAK_API_KEY,
    network: 'lukso', //default network
    defaultCryptoCurrency: 'LYX', // default crypto currency
    cryptoCurrencyCode: 'LYX', // default currency code
    defaultFiatAmount: 20,
    defaultFiatCurrency: 'EUR', // EURO as default FiatCurrency but user can select another currency on UI
    productsAvailed: 'BUY',
    walletAddress: props.address,
    isFeeCalculationHidden: 'true',
    defaultPaymentMethod: 'credit_debit_card',
    hideMenu: 'true',
    themeColor: '243542', // primary UP color,
    exchangeScreenTitle: $t(TRANSAK_TITLE_KEY, { currency: 'LYX' }), // by default buy LYX message
  }

  const specificParams = networkMapping[appStore.network.id] || {}

  const queryParams = {
    ...defaultQueryParams,
    ...specificParams,
  }

  const queryParamsString = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `${TRANSAK_PRODUCTION_API_URL}/?${queryParamsString}`
}

const fundMyAccountViaTransak = () => {
  browser.tabs.create({
    url: encodeURI(transakPurchaseUrl()),
  })
}

const getMoreInformation = () => {
  browser.tabs.create({
    url: 'https://support.lukso.network/extension/guides/fund-controller/',
  })
}

const rampBuyLyxUrl = () => {
  const params = {
    hostLogoUrl: 'https://lukso.network/assets/images/logos/LUKSO_icon.svg',
    hostAppName: 'LUKSO',
    hostApiKey: RAMP_PRODUCTION_API_KEY,
    swapAsset: 'LUKSO_LYX',
    fiatCurrency: 'EUR',
    fiatValue: 20,
    enabledFlows: 'ONRAMP',
    defaultFlow: 'ONRAMP',
    defaultAsset: 'LYX',
    userAddress: props.address,
    paymentMethodType: 'CARD',
    buyLyx: 'ramp',
    finalUrl: encodeURIComponent(`${UNIVERSAL_CLOUD_URL}/${props.address}`),
  }

  const queryParamsString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `${RAMP_PRODUCTION_API_URL}/?${queryParamsString}`
}

const fundMyAccountViaRamp = () => {
  browser.tabs.create({
    url: encodeURI(rampBuyLyxUrl()),
  })
}

const profileStore = useProfileStore()
const deviceController = ref<ControllerDTO>()
watch(
  () => profileStore.getControllerByAddress(props.address),
  async responseDeviceController => {
    if (!responseDeviceController) {
      return
    }
    deviceController.value = responseDeviceController
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "wrapper p-6",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, {
        class: "wider",
        scrollable: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(IconButton, {
              onOnClick: onClose,
              size: "small"
            })
          ]),
          _createElementVNode("div", {
            class: "title mt-6 px-2",
            innerHTML: _unref($t)('app.controller_permissions.fund_controller.instruction')
          }, null, 8 /* PROPS */, _hoisted_2),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _unref(Transak),
                alt: "transak",
                class: "transak"
              }, null, 8 /* PROPS */, _hoisted_5),
              _createVNode(Button, {
                class: "ml-2",
                variant: "secondary",
                size: "small",
                onClick: fundMyAccountViaTransak
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_unref($t)('app.controller_permissions.fund_controller.fund')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)('app.controller_permissions.fund_controller.transak_info', {
              controllerName:
                deviceController.value?.name ||
                _unref($t)(
                  'profile.create.authorized_apps.browser_extension_display_name'
                ),
            })), 1 /* TEXT */),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _unref(Ramp),
                alt: "ramp",
                class: "ramp-logo"
              }, null, 8 /* PROPS */, _hoisted_10),
              _createVNode(Button, {
                class: "ml-2",
                variant: "secondary",
                size: "small",
                onClick: fundMyAccountViaRamp
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_unref($t)('app.controller_permissions.fund_controller.fund')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref($t)('app.controller_permissions.fund_controller.ramp_info', {
              controllerName:
                deviceController.value?.name ||
                _unref($t)(
                  'profile.create.authorized_apps.browser_extension_display_name'
                ),
            })), 1 /* TEXT */)
          ]),
          _createElementVNode("p", {
            class: "footer mt-6",
            onClick: getMoreInformation
          }, _toDisplayString(_unref($t)('app.controller_permissions.fund_controller.find_more')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})